import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import store from './reducer/store'
import { Provider } from 'react-redux'
import './index.css'
import { BrowserRouter } from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* </React.StrictMode> */}
  </Provider>
)
